import CancelIcon from '@material-ui/icons/Cancel';
import { Button, Checkbox, FormControlLabel, IconButton } from '@material-ui/core';
import React, { useEffect, useReducer } from 'react';
import { updateDigitalCheckinConfigs } from '../../../../../../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../../../../../../utils/NotificationUtils';
import { useDispatch } from 'react-redux';
import { fetchDigitalCheckinConfigs } from '../../../../../configurationSlice';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../../../utils/loaderSlice';
import { ENVIRONMENT } from '../../../../../../../env/Configurations';

const ERegForm = (props) => {
  const dispatch = useDispatch();
  const { hotelId, data, toggleDrawer, showLoader = () => {} } = props;

  const [guestInfoForm, setGuestInfoForm] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      middleName: {
        fieldName: 'Middle Name',
        value: false,
        identifier: 'MIDDLE_NAME',
      },
      dateOfBirth: {
        fieldName: 'Date of Birth',
        value: false,
        identifier: 'DATE_OF_BIRTH',
      },
      mailingAddress: {
        fieldName: 'Mailing Address',
        value: false,
        identifier: 'MAILING_ADDRESS',
      },
      countryOfResidence: {
        fieldName: 'Country of Residence',
        value: false,
        identifier: 'COUNTRY_OF_RESIDENCE',
      },
      anniversaryDate: {
        fieldName: 'Anniversary Date',
        value: false,
        identifier: 'ANNIVERSARY_DATE',
      },
    },
  );

  const [docInfoForm, setDocInfoForm] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      documentType: {
        fieldName: 'Document Type',
        value: false,
        identifier: 'DOCUMENT_TYPE',
      },
      documentNumber: {
        fieldName: 'Document Number',
        value: false,
        identifier: 'DOCUMENT_NUMBER',
      },
      dateOfIssue: {
        fieldName: 'Date of Issue',
        value: false,
        identifier: 'DATE_OF_ISSUE',
      },
      dateOfExpiry: {
        fieldName: 'Date of Expiry',
        value: false,
        identifier: 'DATE_OF_EXPIRY',
      },
      country: {
        fieldName: 'Country',
        value: false,
        identifier: 'COUNTRY',
      },
    },
  );

  const [roomDetailForm, setRoomDetailForm] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      roomRate: {
        fieldName: 'Room Rate',
        value: false,
        identifier: 'ROOM_RATE',
      },
      mealPlan: {
        fieldName: 'Meal Plan',
        value: false,
        identifier: 'MEAL_PLAN',
      },
      personalisation: {
        fieldName: 'Personalisation',
        value: false,
        identifier: 'PERSONALISATION',
      },
    },
  );

  const [travelInfoForm, setTravelInfoForm] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      companyName: {
        fieldName: 'Company/Agent Name',
        value: false,
        identifier: 'COMPANY/AGENT_NAME',
      },
      previousVisits: {
        fieldName: 'Previous Visits',
        value: false,
        identifier: 'PREVIOUS_VISITS',
      },
      arrivalFlight: {
        fieldName: 'Arrival Flight',
        value: false,
        identifier: 'ARRIVAL_FLIGHT',
      },
      departureFlight: {
        fieldName: 'Departure Flight',
        value: false,
        identifier: 'DEPARTURE_FLIGHT',
      },
    },
  );

  const handleOnChange = (form, attribute, event, setForm) => {
    if (event && attribute) {
      const formCopy = { ...form };
      formCopy[attribute].value = event.target.checked;

      if (typeof setForm === 'function') {
        setForm(formCopy);
      }
    }
  };

  const onCloseDrawer = () => {
    toggleDrawer('', false, '');
  };

  const refactorPayload = () => {
    return {
      guestInformation: Object.keys(guestInfoForm).map((item) => {
        return {
          name: guestInfoForm[item]?.identifier,
          required: guestInfoForm[item]?.value,
        };
      }),
      documentInformation: Object.keys(docInfoForm).map((item) => {
        return {
          name: docInfoForm[item]?.identifier,
          required: docInfoForm[item]?.value,
        };
      }),
      roomDetails: Object.keys(roomDetailForm).map((item) => {
        return {
          name: roomDetailForm[item]?.identifier,
          required: roomDetailForm[item]?.value,
        };
      }),
      travelInfo: Object.keys(travelInfoForm).map((item) => {
        return {
          name: travelInfoForm[item]?.identifier,
          required: travelInfoForm[item]?.value,
        };
      }),
    };
  };

  const handleSubmit = () => {
    try {
      dispatch(stepUpLoaderCount());
      if (hotelId && data) {
        const payload = {
          hotelId: hotelId,
          eRegistrationForm: refactorPayload(),
        };
        updateDigitalCheckinConfigs(payload).then((res) => {
          dispatch(fetchDigitalCheckinConfigs(hotelId));
          notificationManager('success', 'E-Registration form updated successfully');
          onCloseDrawer();
        });
      }
    } catch (error) {
      if (ENVIRONMENT === 'dev') {
        console.log(error?.message);
      }

      notificationManager('danger', 'Fail to update E-Registration form');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  useEffect(() => {
    if (data) {
      initiateValue(guestInfoForm, data?.guestInformation, setGuestInfoForm);
      initiateValue(docInfoForm, data?.documentInformation, setDocInfoForm);
      initiateValue(roomDetailForm, data?.roomDetails, setRoomDetailForm);
      initiateValue(travelInfoForm, data?.travelInfo, setTravelInfoForm);
    }
  }, [data]);

  const initiateValue = (form, details, formFunc) => {
    for (const [propertyKey, propertyValue] of Object.entries(form)) {
      propertyValue.value =
        details?.find((detail) => detail.name === propertyValue.identifier)?.required ?? false;
      if (typeof formFunc === 'function') {
        formFunc({ [propertyKey]: propertyValue });
      }
    }
  };

  return (
    <div className='e-regform px-4 container pt-4'>
      <div className='row px-3 w-100 mt-4'>
        <div className='col-md-6'>
          <span className='page-title'>Edit e-Registration Form</span>
        </div>
        <div className='col-md-6 d-flex justify-content-end'>
          <IconButton aria-label='delete' onClick={(e) => onCloseDrawer()}>
            <CancelIcon />
          </IconButton>
        </div>
      </div>
      <div className='d-flex flex-column justify-content-between px-3 mt-4'>
        <>
          <div className='e-regform-guest'>
            <div className='hotel-service-subtitle mb-1'>Guest Information</div>
            <div className='d-flex flex-column'>
              {Object.keys(guestInfoForm).map((item) => {
                const obj = guestInfoForm[item];
                return (
                  <FormControlLabel
                    control={
                      <Checkbox
                        color='primary'
                        checked={obj?.value}
                        onChange={(event) =>
                          handleOnChange(guestInfoForm, item, event, setGuestInfoForm)
                        }
                        name={obj?.fieldName}
                      />
                    }
                    label={obj?.fieldName}
                  />
                );
              })}
            </div>
          </div>

          <div className='e-regform-doc-info col-md-7 mt-3'>
            <div className='hotel-service-subtitle mb-1'>Document Information</div>
            <div className='d-flex flex-wrap'>
              {Object.keys(docInfoForm).map((item) => {
                const obj = docInfoForm[item];
                return (
                  <FormControlLabel
                    className='col-md-5'
                    control={
                      <Checkbox
                        color='primary'
                        checked={obj?.value}
                        onChange={(event) =>
                          handleOnChange(docInfoForm, item, event, setDocInfoForm)
                        }
                        name={obj?.fieldName}
                      />
                    }
                    label={obj?.fieldName}
                  />
                );
              })}
            </div>
          </div>

          <div className='e-regform-room-details mt-3 col-md-7'>
            <div className='hotel-service-subtitle mb-1'>Room Details</div>
            <div className='d-flex'>
              {Object.keys(roomDetailForm).map((item) => {
                const obj = roomDetailForm[item];
                return (
                  <FormControlLabel
                    className='col-md-5'
                    control={
                      <Checkbox
                        color='primary'
                        checked={obj?.value}
                        onChange={(event) =>
                          handleOnChange(roomDetailForm, item, event, setRoomDetailForm)
                        }
                        name={obj?.fieldName}
                      />
                    }
                    label={obj?.fieldName}
                  />
                );
              })}
            </div>
          </div>

          <div className='e-regform-travel-info col-md-7 mt-3'>
            <div className='hotel-service-subtitle mb-1'>Travel Information</div>
            <div className='d-flex flex-wrap'>
              {Object.keys(travelInfoForm).map((item) => {
                const obj = travelInfoForm[item];
                return (
                  <FormControlLabel
                    className={`${
                      item === 'arrivalFlight' || item === 'departureFlight'
                        ? 'col-md-5'
                        : 'col-md-12'
                    }`}
                    control={
                      <Checkbox
                        color='primary'
                        checked={obj?.value}
                        onChange={(event) =>
                          handleOnChange(travelInfoForm, item, event, setTravelInfoForm)
                        }
                        name={obj?.fieldName}
                      />
                    }
                    label={obj?.fieldName}
                  />
                );
              })}
            </div>
          </div>
        </>

        <div className='col-md-12 mt-5 d-flex justify-content-start'>
          <Button
            variant='contained'
            type='submit'
            color='primary'
            className='me-3'
            size='large'
            onClick={(e) => handleSubmit()}
          >
            Submit
          </Button>
          <Button
            variant='outlined'
            type='button'
            color='secondary'
            size='large'
            onClick={(e) => onCloseDrawer(e)}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ERegForm;
